import { useEffect, useState } from 'react';
import jwt from 'jsonwebtoken';

import { AxiosPublic } from '../utils/axios';
import { UserProfile } from '../interfaces/userProfile.interface';
import { ResponseException } from '../models';
import { UserType } from '@mvrb-frontend/shared-ui';
import { setUserProfileCookie } from '../utils/auth';

export const useStaffLogin = () => {
  const [isFetching, setFetching] = useState(false);
  const [profile, setProfile] = useState<UserProfile>();
  const [success, setSuccess] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [displayErrors, setDisplayErrors] = useState(false);

  useEffect(() => {
    setDisplayErrors(!isFetching && errors.length > 0);
  }, [isFetching, errors]);

  const submit = async (values: any) => {
    try {
      setFetching(true);
      const response = await AxiosPublic.post('/auth/staff/login', values);
      const { accessToken, refreshToken, user } = response.data;
      const refreshExpiry = jwt.decode(refreshToken).exp;
      const userProfile = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        userType: user.userType as UserType,
        organizations: user.organizations,
      };
      setUserProfileCookie(accessToken, refreshToken, userProfile);
      setProfile(userProfile);
      setFetching(false);
      setSuccess(true);
    } catch (e) {
      setSuccess(false);
      setErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    profile,
    success,
    submit,
    errors,
    displayErrors,
  };
};
